import React from "react";
import "./css/styles.css";
import "./css/styles_600px_min.css";
import "./css/styles_768px_min.css";
import "./css/styles_1200px_min.css";
import "./css/styles_1500px.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Typewriter from 'typewriter-effect';

const PortfolioPage = () => {
  React.useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      {/* Profile Section */}
      <div
        className="section profile"
        data-aos="fade-down"
        data-aos-duration="800"
        data-aos-easing="ease-out"
      >
        <div className="content">
          <img
            className="profile"
            src="../assets/img/profile.jpeg"
            width="487px"
            height="500px"
            alt="GOKULAKRISHNAN A B - Profile Picture"
          />
          <h1 id="title">GOKULAKRISHNAN A B</h1>
          <div className="profile">
          <div className="typewriterContainer">
      <Typewriter
        options={{
          strings: ['Freelancer','Software Developer', 'UI/UX Designer' ],
          autoStart: true,
          loop: true,
        }}
      />
    </div>
          </div>

          {/* Social Links */}
          <a
            href="https://github.com/dark-pixels"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Github"
            data-splitbee-event-type="github"
          >
            <img
              alt="Github Profile"
              className="icon"
              width="64px"
              height="64px"
              src="../assets/img/github.png"
            />
          </a>
          <a
            href="https://www.linkedin.com/in/gokulab"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Linked In"
            data-splitbee-event-type="linkedin"
          >
            <img
              width="64px"
              height="64px"
              alt="LinkedIn Profile"
              className="icon"
              src="../assets/img/linkedin.png"
            />
          </a>
          <a
            href="https://twitter.com/gokul722722"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Twitter"
            data-splitbee-event-type="twitter"
          >
            <img
              alt="Twitter Profile"
              className="icon"
              width="64px"
              height="64px"
              src="../assets/img/twitter.png"
            />
          </a>
          <a
            href="https://www.instagram.com/_dark_pixels__/"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Instagram"
            data-splitbee-event-type="instagram"
          >
            <img
              alt="Instagram Profile"
              className="icon"
              width="64px"
              height="64px"
              src="../assets/img/instagram.png"
            />
          </a> 
          <br/><br/><br/><br/><br/><br/><br/><br/>
          <p className="down sss">
          <a href="#about" style={{ textDecoration: "none" }}>
            Scroll Down
          </a>
        </p>
        </div>
        
      </div>

      {/* About Section */}
      <div id="about" className="section about skills">
        <div
          className="content"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-easing="ease-out"
        >
           <h1 className="hi">
            <Typewriter
              options={{
                strings: ["ABOUT ME"],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />
          </h1>
          <p>Heyyy!</p>
          <p>
          I am an engineering student and a freelance web developer and UI/UX designer.
          </p>
          <p>
          I run my own brand, <a href="">DarkPixels</a>, which focuses on providing digital solutions for startups and small businesses. Our services include website development and graphic design, helping clients establish a strong and unique online presence. My goal is to deliver high-quality solutions that empower businesses to grow and stand out in the digital space.

          </p>
          <p>
          Balancing my engineering studies and freelancing, I continue to hone my skills and build a diverse portfolio. I am passionate about blending technology with creativity to solve real-world problems and make a meaningful impact in the industry.
          </p>
        </div>
      </div>

      {/* Experience Section */}
      <div id="experience" className="section experience skills">
        <div
          className="content"
          data-aos="fade-down"
          data-aos-duration="800"
          data-aos-easing="ease-out"
        >
          <h1 className="hi">
            <Typewriter
              options={{
                strings: ["EXPERIENCE"],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />
          </h1>
          <div className="container">
            <div className="row">
              <div className="card" data-aos="fade-up">
                <img
                  width="22px"
                  height="22px"
                  src="/assets/img/bl_logo.png"
                  alt="Byteplexure"
                />
                <div className="card_text">
                  <h3>DARKPIXELS</h3>
                  <p>Freelance - Software Developer</p>
                  <p className="text-light">Jan 2022 - Present</p>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                <img
                  width="22px"
                  height="22px"
                  src="/assets/img/sfc_logo.png"
                  alt="SFC Transport"
                />
                <div className="card_text">
                  <h3>Zelf Life Technology</h3>
                  <p>Full-stack Developer Intern</p>
                  <p className="text-light">Aug 2024 - Oct 2024 (3 mos) </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Section */}
      <div id="skills" className="section skills">
        <div
          className="content"
          data-aos="fade-down"
          data-aos-duration="800"
          data-aos-easing="ease-out"
        >
         <h1 className="hi">
            <Typewriter
              options={{
                strings: ["SKILLS"],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />
          </h1>
          <div className="container">
            <div className="row">
              <div className="card" data-aos="fade-up">
                <img
                  width="22px"
                  height="22px"
                  src="/assets/img/html5.png"
                  alt="Web Development"
                />
                <div className="card_text">
                  <h3>Web Design and Development</h3>
                  <p>HTML, CSS, Javascript, Tailwindcss</p>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                <img
                  width="22px"
                  height="22px"
                  src="/assets/img/React.png"
                  alt="Frontend Javascript Frameworks"
                />
                <div className="card_text">
                  <h3>Frontend Javascript Frameworks</h3>
                  <p>React JS</p>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                <img
                  src="/assets/img/figmalogo.png"
                  width="22px"
                  height="22px"
                  alt="Backend Javascript Frameworks"
                />
                <div className="card_text">
                  <h3>UI/UX Designer</h3>
                  <p>Figma</p>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                <img
                  width="22px"
                  height="22px"
                  src="/assets/img/ps.png"
                  alt="Frontend Javascript Frameworks"
                />
                <div className="card_text">
                  <h3>Graphic Design</h3>
                  <p>Adobe Photoshop and Illustrator</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Projects Section */}
      <div id="projects" className="section projects">
        <div
          className="content"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-easing="ease-out"
        >
          <h1 className="hi">
            <Typewriter
              options={{
                strings: ["PROJECTS"],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />
          </h1>
          <div className="container">
            <div className="row">
              <div className="card" data-aos="fade-up">
                
                <div className="card_text">
                  <h3>Pixel Auction Center</h3>
                  <p>A versatile auction platform combining with e-commerce, enabling users to buy products, auction their used items, and participate in live auctions to purchase exclusive goods. Bridging convenience and excitement in one platform!</p>
                  <a href="https://github.com/dark-pixels/Pixel-Auction-Center" target="_blank" rel="noopener noreferrer">
                    <img alt="GitHub" className="icon" width="30" height="30" src="/assets/img/github.png" />
                   
                  </a>
                  <a href="https://mediumvioletred-coyote-496600.hostingersite.com/" target="_blank" rel="noopener noreferrer">
                    <img alt="Live Project" className="icon" width="30" height="30" src="/assets/img/globe.png" />
                    
                  </a>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
               
                <div className="card_text">
                  <h3>Pixel Movie Booking</h3>
                  <p>
Pixel Movie Booking
Pixel Movie Booking
Nov 2024 - Nov 2024Nov 2024 - Nov 2024
I created a movie booking website called "Pixel Mobile Booking" using React. It focuses solely on the frontend to offer an engaging and seamless user experience. This project showcases my skills in React development.</p>
                  <a href="https://github.com/dark-pixels/Movie-Booking" target="_blank" rel="noopener noreferrer">
                    <img alt="GitHub" className="icon" width="30" height="30" src="/assets/img/github.png" />
                   
                  </a>
                  <a href="https://peachpuff-kudu-288488.hostingersite.com/" target="_blank" rel="noopener noreferrer">
                    <img alt="Live Project" className="icon" width="30" height="30" src="/assets/img/globe.png" />
                    
                  </a>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                
                <div className="card_text">
                  <h3>
                  OBSA</h3>
                  <p>I created a website named myobsa.com  during for a new brand that collects and stores user data.</p>
                  <a href="https://github.com/dark-pixels/obsa-project" target="_blank" rel="noopener noreferrer">
                    <img alt="GitHub" className="icon" width="30" height="30" src="/assets/img/github.png" />
                   
                  </a>
                  <a href="https://myobsa.com/" target="_blank" rel="noopener noreferrer">
                    <img alt="Live Project" className="icon" width="30" height="30" src="/assets/img/globe.png" />
                    
                  </a>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                
                <div className="card_text">
                  <h3>Creative portfolio website</h3>
                  <p>Create a portfolio website for myself as a step into web development.</p>
                  <a href="https://github.com/dark-pixels/Portfolio.com" target="_blank" rel="noopener noreferrer">
                    <img alt="GitHub" className="icon" width="30" height="30" src="/assets/img/github.png" />
                   
                  </a>
                  <a href="https://dark-pixels.github.io/Portfolio.com/" target="_blank" rel="noopener noreferrer">
                    <img alt="Live Project" className="icon" width="30" height="30" src="/assets/img/globe.png" />
                    
                  </a>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                
                <div className="card_text">
                  <h3>
                  AIM SAT</h3>
                  <p>Made a satellite in 5 cm cube and weighed less than 50g. which was launched by NDRF (National design and research forum) at
                  VIT(Vellore Institute of Technology).</p>
                
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                
                <div className="card_text">
                  <h3>
                  Greenhouse Gas level identifier</h3>
                  <p>Making a drone which can identify the level of greenhouse gases in the different altitudes and also making an application to control both drone and to display the output of the altitude and gas level obtained from the device.</p>
                 
                </div>
              </div>
              
                
                
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact" className="section contact">
        <div className="content">
        <h1 className="hi">
            <Typewriter
              options={{
                strings: ["CONTACT"],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />
          </h1>
          <div>
        <div className="content1">

          {/* Social Links */}
          <a
            href="https://github.com/dark-pixels"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Github"
            data-splitbee-event-type="github"
          >
            <img
              alt="Github Profile"
              className="icon1"
              width="64px"
              height="64px"
              src="../assets/img/github.png"
            />
          </a>
          <a
            href="https://www.linkedin.com/in/gokulab"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Linked In"
            data-splitbee-event-type="linkedin"
          >
            <img
              width="64px"
              height="64px"
              alt="LinkedIn Profile"
              className="icon1"
              src="../assets/img/linkedin.png"
            />
          </a>
          <a
            href="https://twitter.com/gokul722722"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Twitter"
            data-splitbee-event-type="twitter"
          >
            <img
              alt="Twitter Profile"
              className="icon1"
              width="64px"
              height="64px"
              src="../assets/img/twitter.png"
            />
          </a>
          <a
            href="https://www.instagram.com/_dark_pixels__/"
            className="links"
            target="_blank"
            rel="noreferrer"
            data-splitbee-event="Instagram"
            data-splitbee-event-type="instagram"
          >
            <img
              alt="Instagram Profile"
              className="icon1"
              width="64px"
              height="64px"
              src="../assets/img/instagram.png"
            />
          </a>
        </div>
      
      </div> 
        </div>
      

      {/* Footer */}
      
        
          <p className="bt">
            Made with{" "}
            <span role="img" aria-label="love">
              ❤️
            </span>{" "}
            by GOKULAKRISHNAN A B
          </p>
          </div>
        
      
    </div>
  );
};

export default PortfolioPage;
